var _module_exports = "<source-filters capture-mode=\"captureMode\"></source-filters>";;
var path = '/builds/observability/imm/signalview/src/app/dashboard/sourceFiltersIsolate.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;